module.exports = __webpack_public_path__ + "static/media/fo.baecdf46.svg";